import { BASE_URL } from 'constants/api';
import actions from './index';

export const ACTIONS = {
  GET: 'FOUNDATION_STUDENT_PAYMENT_LINK_GET',
  GET_SUCCESS: 'FOUNDATION_STUDENT_PAYMENT_LINK_GET_SUCCESS',
  GET_FAILURE: 'FOUNDATION_STUDENT_PAYMENT_LINK_GET_FAILURE',

  POST: 'FOUNDATION_STUDENT_PAYMENT_LINK_POST',
  POST_SUCCESS: 'FOUNDATION_STUDENT_PAYMENT_LINK_POST_SUCCESS',
  POST_FAILURE: 'FOUNDATION_STUDENT_PAYMENT_LINK_POST_FAILURE',
};

export const post = actions.post(
  (id, data, { studentServiceId }) =>
    `${BASE_URL}/foundation-student/${studentServiceId}/`,
  {
    PENDING: ACTIONS.POST,
    SUCCESS: ACTIONS.POST_SUCCESS,
    FAILURE: ACTIONS.POST_FAILURE,
  },
);

export const get = actions.get(
  studentServiceId => `${BASE_URL}/foundation-student/${studentServiceId}/`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
